var React = require('react');

function ArrowCtaRed (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Desktop","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"dominos-homepage-desktop-state2","fill":"#D51A35"},React.createElement("g",{"id":"CALIFORNIA"},React.createElement("g",{"id":"CTA-arrow"},React.createElement("path",{"d":"M111.847843,0.446116206 C111.445386,0.0128185165 110.832953,-0.119054693 110.296345,0.113293343 C109.783067,0.351921056 109.433105,0.910812278 109.433105,1.52622059 L109.433105,30.5383267 L1.41151324,30.5383267 C0.641596928,30.5383267 0,31.2228115 0,32.0642882 L0,75.9341093 C0,76.775586 0.641596928,77.4600707 1.41151324,77.4600707 L109.433105,77.4600707 L109.433105,106.478457 C109.433105,107.093865 109.783067,107.646476 110.296345,107.885104 C110.832953,108.117452 111.445386,107.991859 111.847843,107.558561 L160.580046,55.0793031 C161.139985,54.4827338 161.139985,53.5219433 160.580046,52.925374 L111.847843,0.446116206 Z","id":"Fill-1","transform":"translate(80.500000, 54.000000) rotate(-180.000000) translate(-80.500000, -54.000000) "}))))));
}

ArrowCtaRed.defaultProps = {"width":"161px","height":"108px","viewBox":"0 0 161 108","version":"1.1"};

module.exports = ArrowCtaRed;

ArrowCtaRed.default = ArrowCtaRed;



//////////////////
// WEBPACK FOOTER
// ./src/static/svgs/arrow-cta-red.svg
// module id = 100
// module chunks = 35783957827783 159909797682334